import React, { useEffect, useState } from 'react';
import DocumentInputMasked from './masks/DocumentInputMasked';
import ZipCodeInputMasked from './masks/ZipCodeInputMasked';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { states } from '../utils/states.js';
import AddressInput from './AddressInput.jsx';
import useErrors from '../hook/useErrors.jsx';
import axios from 'axios';
import server from '../services/server.js';
import { useFetch } from '../hook/useFecth.jsx';
import Step1 from '../assets/imgs/step1.png';
import Step2 from '../assets/imgs/step2.png';
import Step3 from '../assets/imgs/step3.png';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';


const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nome completo é obrigatório').min(3, 'Nome deve ter pelo menos 3 caracteres'),
    document: Yup.string().required('Documento (CPF) é obrigatório').min(11, 'O documento deve ter 11 caracteres'),
    email: Yup.string().email('E-mail inválido').required('E-mail é obrigatório'),
    phone: Yup.string().required('Telefone obrigatório').min(11, 'Telefone deve ter pelo menos 11 caracteres'),
    zipcode: Yup.string().required('CEP é obrigatório').min(8, 'CEP deve ter 8 caracteres'),
    city: Yup.string().required('Cidade é obrigatório'),
    state: Yup.string().required('Estado é obrigatório'),
    complementAddress: Yup.string(),
    address: Yup.string().required('Endereço é obrigatório'),
    number: Yup.string().required('Número é obrigatório'),
    nationality: Yup.string().required('Nacionalidade é obrigatória'),
    maritalStatus: Yup.string().required('Estado civil é obrigatório'),
    occupation: Yup.string().required('Informe sua ocupação'),
    creci: Yup.string().required('CRECI é obrigatório'),
    creciUf: Yup.string().required('CRECI-UF é obrigatório'),
});

function PersonalComponent({ data, mutate, nextStep, prevStep }) {
    const { setErrors, toast } = useErrors();
    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, touched, values, setValues } = useFormik({
        initialValues: {
            name: '',
            document: '',
            email: '',
            phone: '',
            zipcode: '',
            city: '',
            state: '',
            address: '',
            complementAddress: '',
            number: '',
            nationality: '',
            maritalStatus: '',
            creci: '',
            creciUf: '',
            occupation: '',
            step: 2,
        },
        validationSchema: validationSchema,
        validateOnMount: true,
        validateOnChange: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                await server.put(`profile`, values);
                await mutate();
                nextStep();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const { id, step, ...profile } = data;
            setValues({ ...profile, step: 2 }, true);
        }
    }, [data]);

    return (
        <form onSubmit={handleSubmit} className="wizard-form" id="personal">
            <h6 className="text-md text-neutral-500">Informações pessoais</h6>
            <div className="row gy-3">
                <div className="col-sm-6">
                    <label className="form-label">Nome completo</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            className={`form-control wizard-required ${touched.name && errors.name ? 'is-invalid' : ''}`}
                            placeholder="Nome completo"
                            {...getFieldProps('name')}
                            required="required"
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-6">
                    <label className="form-label">Documento</label>
                    <div className="position-relative">
                        <DocumentInputMasked
                            className={`form-control wizard-required ${touched.document && errors.document ? 'is-invalid' : ''}`}
                            placeholder="Documento"
                            {...getFieldProps('document')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-6">
                    <label className="form-label">E-mail*</label>
                    <div className="position-relative">
                        <input
                            type="email"
                            className={`form-control wizard-required ${touched.email && errors.email ? 'is-invalid' : ''}`}
                            placeholder="E-mail"
                            required=""
                            {...getFieldProps('email')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-6">
                    <label className="form-label">Telefone</label>
                    <div className="position-relative">
                        <input
                            className={`form-control wizard-required ${touched.phone && errors.phone ? 'is-invalid' : ''}`}
                            placeholder="Telefone"
                            required=""
                            {...getFieldProps('phone')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>

                <AddressInput
                    onChangeAddress={address => setValues({ ...values, ...address })}
                    {...getFieldProps('zipcode')}
                    error={errors.zipcode}
                    touched={touched.zipcode}
                />
                <div className="col-sm-4">
                    <label className="form-label">Rua</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            readOnly
                            className={`form-control wizard-required ${touched.address && errors.address ? 'is-invalid' : ''}`}
                            placeholder="Complemento"
                            {...getFieldProps('address')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-4">
                    <label className="form-label">Cidade</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            readOnly
                            className={`form-control wizard-required ${touched.city && errors.city ? 'is-invalid' : ''}`}
                            placeholder="Complemento"
                            {...getFieldProps('city')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-4">
                    <label className="form-label">Estado</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            readOnly
                            className={`form-control wizard-required ${touched.state && errors.state ? 'is-invalid' : ''}`}
                            placeholder="Complemento"
                            {...getFieldProps('state')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-4">
                    <label className="form-label">Complemento</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            className={`form-control wizard-required ${touched.complementAddress && errors.complementAddress ? 'is-invalid' : ''}`}
                            placeholder="Complemento"
                            {...getFieldProps('complementAddress')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>

                <div className="col-sm-4">
                    <label className="form-label">Número*</label>
                    <div className="position-relative">
                        <input
                            className={`form-control wizard-required ${touched.number && errors.number ? 'is-invalid' : ''}`}
                            {...getFieldProps('number')}
                            placeholder="Número"
                            required=""
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-4">
                    <label className="form-label">Ocupação*</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            required
                            className={`form-control wizard-required ${touched.occupation && errors.occupation ? 'is-invalid' : ''}`}
                            placeholder="Opcuação"
                            {...getFieldProps('occupation')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-4">
                    <label className="form-label">Nacionalidade</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            required
                            className={`form-control wizard-required ${touched.nationality && errors.nationality ? 'is-invalid' : ''}`}
                            placeholder="Nacionalidade"
                            {...getFieldProps('nationality')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-4">
                    <label className="form-label">Estado Civil</label>
                    <div className="position-relative">
                        <select
                            className={`form-control form-select wizard-required ${
                                touched.maritalStatus && errors.maritalStatus ? 'is-invalid' : ''
                            }`}
                            defaultValue=""
                            required
                            {...getFieldProps('maritalStatus')}
                        >
                            <option value="" className={`form-control wizard-required`}>
                                Selecione um item
                            </option>
                            <option value="Casado">Casado</option>
                            <option value="Solteiro">Solteiro</option>
                            <option value="Viúvo">Viúvo</option>
                            <option value="Divorciado">Divorciado</option>
                        </select>
                        <div className="wizard-form-error" />
                    </div>
                </div>

                <div className="col-sm-6">
                    <label className="form-label">CRECI</label>
                    <div className="position-relative">
                        <input
                            className={`form-control wizard-required ${touched.creci && errors.creci ? 'is-invalid' : ''}`}
                            placeholder="Documento"
                            required
                            {...getFieldProps('creci')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>
                <div className="col-sm-6">
                    <label className="form-label">CRECI-UF</label>
                    <div className="position-relative">
                        <select
                            className={`form-control form-select wizard-required ${touched.creciUf && errors.creciUf ? 'is-invalid' : ''}`}
                            defaultValue=""
                            {...getFieldProps('creciUf')}
                        >
                            <option value="" className={`form-control wizard-required ${touched.creciUf && errors.creciUf ? 'is-invalid' : ''}`}>
                                Selecione o UF
                            </option>
                            {states.map(state => (
                                <option key={state.value} value={state.value}>
                                    {state.label}
                                </option>
                            ))}
                        </select>

                        <div className="wizard-form-error" />
                    </div>
                </div>

                <div className="form-group text-end">
                    <button
                        disabled={!isValid || isSubmitting}
                        type="submit"
                        form="personal"
                        className="btn btn-primary-600 form-wizard-next-btn px-32"
                    >
                        Salvar e continuar
                    </button>
                </div>
            </div>
        </form>
    );
}

function ContasAsaas({ data, mutate, nextStep, prevStep }) {
    const { setErrors, toast } = useErrors();
    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, touched, values, setValues } = useFormik({
        initialValues: {
            walletId: '',
        },
        validationSchema: Yup.object().shape({
            walletId: Yup.string().required('Wallet ID é obrigatório'),
        }),
        validateOnMount: true,
        validateOnChange: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                await server.put(`profile`, values);
                await mutate();
                nextStep();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const { id, step, walletId, ...profile } = data;
            setValues({ walletId, step: 3 }, true);
        }
    }, [data]);
    return (
        <form id="wallet" onSubmit={handleSubmit} className="wizard-form">
            <h6 className="text-md text-neutral-500">Conta para recebimento</h6>
            <div className="row gy-3">
                <p className="text-neutral-500">Nosso sistema trabalha com pagamento imediato e integrado a sua carteira de recebimento.</p>
                <p className="text-neutral-500">
                    Para criar sua carteira visite o site asaas.com, crie uma conta e siga as instruções abaixo para integrar sua carteira de
                    recebimento com nosso sistema.
                </p>
                <div className="row align-items-center gx-4">
                    <div className="col-md-4">
                        <div className="card border">
                            <div className="flex card-body">
                                <img src={Step1} className="card-image-top-100 border rounded mb-5" />
                                <p className="card-text text-center">
                                    <strong>Clique no menu superior direito como na imagem.</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border">
                            <div className="card-body">
                                <img src={Step2} className="card-image-top-100 border rounded mb-5" />
                                <p className="card-text text-center">
                                    <strong>Ao abrir o menu selecione a opção integrações</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border">
                            <div className="card-body">
                                <img src={Step3} className="card-image-top-100 border rounded mb-5" />
                                <p className="card-text text-center">
                                    <strong>Você deve copiar o codigo da sua walletID </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4col-12">
                    <label className="form-label">Wallet ID - Asaas</label>
                    <div className="position-relative">
                        <input
                            type="text"
                            className={`form-control wizard-required ${touched.walletId && errors.walletId ? 'is-invalid' : ''}`}
                            placeholder="Cole aqui o seu Wallet ID"
                            required=""
                            {...getFieldProps('walletId')}
                        />
                        <div className="wizard-form-error" />
                    </div>
                </div>

                <div className="d-flex form-group align-items-center justify-content-end gap-8">
                    <button onClick={prevStep} type="button" className="btn btn-neutral-500 form-wizard-previous-btn border-neutral-100 px-32">
                        Voltar
                    </button>
                    <button
                        type="submit"
                        form="wallet"
                        disabled={!isValid || isSubmitting}
                        className="btn btn-primary-600 form-wizard-next-btn px-32"
                    >
                        Continuar
                    </button>
                </div>
            </div>
        </form>
    );
}

function Contracts({ data, mutate, nextStep, prevStep }) {
    //const { data: listContracts, mutate: mutateListcontracts } = useFetch(`contract`, { params: { type: 'broker' } });

    const { setErrors, toast, confirm } = useErrors();
    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, touched, values, setValues } = useFormik({
        initialValues: {
            type: 'broker',
        },

        onSubmit: async (values, { setSubmitting }) => {
            try {
                await confirm({
                    title: 'Gerar contrato',
                    message: 'Seu contrato será gerado e enviado para assinatura digital no email cadastrado.',
                });
                await server.post(`contract`, values);
                mutate()
                //mutateListcontracts();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    if (Boolean(data?.contractBrokerId))
        return (
            <>
                <div className="card">
                    <div className="card-body border text-center">
                        <div className="text-center">
                            <Icon icon="mdi:sign" fontSize={60} className="text-center" />
                            <p className="g-0 text-center h5">Assinatura do contrato</p>
                        </div>
                        {data?.contractBroker?.status === 'WAITING' && (
                            <div
                                className="alert alert-warning align-self-center text-center w-50"
                                style={{ marginLeft: 'auto', marginRight: 'auto' }}
                            >
                                Aguardando assinatura
                            </div>
                        )}

                        {data?.contractBroker?.status === 'SIGNED' && (
                            <div
                                className="alert alert-success align-self-center text-center w-50 mh-auto"
                                style={{ marginLeft: 'auto', marginRight: 'auto' }}
                            >
                                CONTRATO ASSINADO
                            </div>
                        )}
                    </div>
                </div>
            </>
        );

    return (
        <>
            <div className="card">
                <div className="flex-row card-body border justify-justify-content-center text-center">
                    <div className="text-center">
                        <Icon icon="mdi:sign" fontSize={60} className="text-center" />
                        <p className="g-0 text-center h5">Assinatura do contrato</p>
                    </div>
                    <p className="text-body text-center">
                        Para prosseguirmos com a parceria você deve assinar digitalmente o contrato de parceria da plataforma.
                    </p>
                    <p className="text-body text-center">
                        Clique abaixo para gerar o contrato. Ele será enviado para o seu e-mail cadastrado: <strong>{data?.email}</strong>.
                    </p>
                    <p className="text-body text-center">
                        <strong>Ao assinar o sistema irá processar e liberar seu cadastro. Volte aqui para finalizar o processo.</strong>
                    </p>

                    <button type="button" onClick={handleSubmit} className="btn btn-success-600 form-wizard-next-btn px-32">
                        Gerar contrato
                    </button>
                </div>
            </div>
        </>
    );
}

function Sign({ data, mutate, nextStep, prevStep }) {
    const { setErrors, toast } = useErrors();

    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, touched, values, setValues } = useFormik({
        initialValues: {
            step: '',
            contractBrokerId: '',
            contractBroker: null
        },
        
        validationSchema: Yup.object().shape({
            contractBrokerId: Yup.string().required('Contrato é obrigatório'),
            contractBroker: Yup.object().shape({
                signedAt: Yup.date().required()
            }).required('Contrato é obrigatório'),
        }),
        validateOnMount: true,
        validateOnChange: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                console.log("VALUES: ", values)
                await server.put(`profile`, values);
                await server.put(`profile/validation`);
                mutate();
                nextStep();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const { id, step, contractBrokerId, profileType,contractBroker, ...profile } = data;
             
            console.log(contractBroker)
            setValues({ profileType, contractBrokerId,contractBroker, step: 4 }, true);
        }
    }, [data]);

    return (
        <>
            <h6 className="text-md text-neutral-500">Assinatura do contrato</h6>
            <Contracts data={data} mutate={mutate} />
            <div className="row gy-3 pt-20">
                <div className="d-flex form-group align-items-center justify-content-end gap-8">
                    <button onClick={prevStep} type="button" className="btn btn-neutral-500 form-wizard-previous-btn border-neutral-100 px-32">
                        Voltar
                    </button>
                    <button
                        type="submit"
                        disabled={!isValid || isSubmitting}
                        onClick={handleSubmit}
                        className="btn btn-primary-600 form-wizard-next-btn px-32"
                    >
                        Salvar e continuar
                    </button>
                </div>
            </div>
        </>
    );
}

function Validate({ data, mutate }) {
    const { setErrors, toast } = useErrors();
    const navigate = useNavigate();
    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, touched, values, setValues } = useFormik({
        initialValues: {
            step: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const { data } = await server.put(`profile/validation`);
                mutate();
                navigate(`/imoveis`);
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const { id, step, contractBrokerId, profileType, ...profile } = data;
            setValues({ profileType, contractBrokerId, step: 4 }, true);
        }
    }, [data]);

    return (
        <>
            {/* <h6 className="text-md text-neutral-500">Cadastro completo</h6> */}
            <div className="row gy-3">
                <div className="text-center mb-40">
                    <img src="assets/images/gif/success-img3.gif" alt="" className="gif-image mb-24" />
                    <h6 className="text-md text-neutral-600">Parabéns </h6>
                    <p className="text-neutral-400 text-sm mb-0">Você completou seu cadastro. Já pode cadastrar imóveis.</p>
                </div>
                <div className="d-flex form-group align-items-center justify-content-end gap-8">
                    <button type="button" onClick={handleSubmit} className="btn btn-primary-600 form-wizard-submit px-32">
                        Cadastrar imóvel
                    </button>
                </div>
            </div>
        </>
    );
}
const ValidateAccountLayer = () => {
    const { data, mutate, isValidating } = useFetch(`profile`);
    
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => {
        if (currentStep < 5) {
            setCurrentStep(currentStep + 1);
        }
    };

    const prevStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    useEffect(() => {
        if (data) {
            setCurrentStep(data.step);
        }
    }, [data]);

    return (
        <>
            <div className="card">
                <div className="card-body mt-50">
                    <h6 className="text-center text-xl mb-4">Vamos validar seu cadastro</h6>
                    <p className="text-center text-neutral-500">Todos os campos são obrigatórios. Preencha com atenção.</p>
                    {/* Form Wizard Start */}
                    <div className="form-wizard">
                        <>
                            <div className="form-wizard-header my-32 overflow-x-auto pb-8 scroll-sm">
                                <ul className="form-wizard-list list-unstyled">
                                    <li
                                        className={`form-wizard-list__item
                      ${[1, 2, 3, 4, 5].includes(currentStep) && 'activated'}
                    ${currentStep === 0 && 'active'} `}
                                    >
                                        <div className="form-wizard-list__line">
                                            <span className="count">1</span>
                                        </div>
                                        <span className="text-xs fw-semibold text">Perfil </span>
                                    </li>
                                    <li
                                        className={`form-wizard-list__item
                      ${[2, 3, 4, 5].includes(currentStep) && 'activated'}
                    ${currentStep === 1 && 'active'} `}
                                    >
                                        <div className="form-wizard-list__line">
                                            <span className="count">2</span>
                                        </div>
                                        <span className="text-xs fw-semibold text">Conta Asaas</span>
                                    </li>
                                    <li
                                        className={`form-wizard-list__item
                      ${[3, 4, 5].includes(currentStep) && 'activated'}
                    ${currentStep === 2 && 'active'} `}
                                    >
                                        <div className="form-wizard-list__line">
                                            <span className="count">3</span>
                                        </div>
                                        <span className="text-xs fw-semibold text">Contrato</span>
                                    </li>
                                    <li
                                        className={`form-wizard-list__item
                      ${[4, 5].includes(currentStep) && 'activated'}
                    ${currentStep === 4 && 'active'} `}
                                    >
                                        <div className="form-wizard-list__line">
                                            <span className="count">4</span>
                                        </div>
                                        <span className="text-xs fw-semibold text">Completo</span>
                                    </li>
                                    {/* <li
                                        className={`form-wizard-list__item

                    ${currentStep === 6 && 'active'} `}
                                    >
                                        <div className="form-wizard-list__line">
                                            <span className="count">5</span>
                                        </div>
                                        <span className="text-xs fw-semibold text">Completed</span>
                                    </li> */}
                                </ul>
                            </div>
                            <fieldset className={`wizard-fieldset ${currentStep === 1 && 'show'} `}>
                                <PersonalComponent nextStep={nextStep} prevStep={prevStep} data={data} mutate={mutate} />
                            </fieldset>
                            <fieldset className={`wizard-fieldset ${currentStep === 2 && 'show'} `}>
                                <ContasAsaas nextStep={nextStep} prevStep={prevStep} data={data} mutate={mutate} />
                            </fieldset>
                            <fieldset className={`wizard-fieldset ${currentStep === 3 && 'show'} `}>
                                <Sign nextStep={nextStep} prevStep={prevStep} data={data} mutate={mutate} />
                            </fieldset>
                            <fieldset className={`wizard-fieldset ${currentStep === 4 && 'show'} `}>
                                <Validate data={data} mutate={mutate} />
                            </fieldset>
                            <fieldset className={`wizard-fieldset ${currentStep === 5 && 'show'} `}></fieldset>
                        </>
                    </div>
                    {/* Form Wizard End */}
                </div>
            </div>
        </>
    );
};

export default ValidateAccountLayer;
